export default "__VITE_ASSET__485f8497__"